import store from "../store";

import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "../components/GeneralViews/NotFoundPage.vue";
// Dashboard pages
const Overview = () =>
  import(
    /* webpackChunkName: "widgets" */ "src/components/Dashboard/Views/Dashboard/Overview.vue"
  );

// Pages
// Users
import UserEdit from "src/components/Dashboard/Views/Pages/Users/UserEdit.vue";
// Accounts
import SelectAccount from "src/components/Dashboard/Views/Pages/AccountSelect.vue";

// Submerchants
import SubmerchantsList from "src/components/Dashboard/Views/Pages/Submerchants/SubmerchantsList.vue";
import SubmerchantsPerformanceList from "src/components/Dashboard/Views/Pages/Submerchants/SubmerchantsPerformanceList.vue";
import SubmerchantPage from "src/components/Dashboard/Views/Pages/Submerchants/SubmerchantPage.vue";
import SubmerchantPerformancePage from "src/components/Dashboard/Views/Pages/Submerchants/SubmerchantPerformancePage.vue";

// Sales
import SalesList from "src/components/Dashboard/Views/Sales/SalesList.vue";
import SalePage from "src/components/Dashboard/Views/Pages/Sales/SalePage.vue";

// Terminals
import TerminalsList from "src/components/Dashboard/Views/Pages/Terminals/TerminalsList.vue";
import TerminalPage from "src/components/Dashboard/Views/Pages/Terminals/TerminalPage.vue";

// Payouts
import PayoutsList from "src/components/Dashboard/Views/Pages/Payouts/PayoutsList.vue";
import PayoutPage from "src/components/Dashboard/Views/Pages/Payouts/PayoutPage.vue";

import Login from "src/components/Dashboard/Views/Pages/Login.vue";
import Register from "src/components/Dashboard/Views/Pages/Register.vue";
import ForgottenPassword from "src/components/Dashboard/Views/Pages/ForgottenPassword.vue";
import ResetPassword from "src/components/Dashboard/Views/Pages/ResetPassword.vue";

// Developer Tools
import DevelopersPage from "src/components/Dashboard/Views/Pages/Developers/DevelopersPage.vue";
import EndpointNotifications from "src/components/Dashboard/Views/Pages/Developers/EndpointNotifications.vue";

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login,
  meta: {
    authRequired: false
  }
};

let forgottenPasswordPage = {
  path: "/forgot-password",
  name: "Forgotten Password",
  component: ForgottenPassword,
  meta: {
    authRequired: false
  }
};

let resetPasswordPage = {
  path: "/reset-password",
  name: "Reset Password",
  component: ResetPassword,
  meta: {
    authRequired: false
  }
};

let registerPage = {
  path: "/register",
  name: "Register",
  component: Register,
  meta: {
    authRequired: false
  }
};

let accountSelectPage = {
  path: "/select-account",
  name: "Select account",
  component: SelectAccount,
  meta: {
    authRequired: true
  },
  beforeEnter: clearSelectedAccount
};

let userMenu = {
  path: "/user",
  component: DashboardLayout,
  redirect: "/user/edit",
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "edit",
      name: "Edit user",
      component: UserEdit
    }
  ]
};

function checkForSelectedAccount(to, from, next) {
  // check whether user has an operator set to localstorage
  const account = store.state.operator;
  if (account) {
    const accountUser = store.state.operatorUser;

    if (accountUser) {
      return next();
    } else {
      // load account user and set it
      window.axios
        .get(`/v1/operators/${account.id}/users/current`)
        .then(response => {
          store.commit("SET_OPERATOR_USER", response.data);
          return next();
        })
        .catch(err => {
          console.error("error loading account user: ", err); // TODO: handle this error better?
          return next();
        });
    }
  } else {
    return next("/select-account");
  }
}

function clearSelectedAccount(to, from, next) {
  store.commit("SET_OPERATOR", null);
  return next();
}

const dashboardMenu = {
  path: "/dashboard",
  component: DashboardLayout,
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "/",
      name: "Account Dashboard",
      component: Overview
    }
  ]
};

const transactionsMenu = {
  path: "/transactions",
  component: DashboardLayout,
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "sales",
      name: "Sales",
      component: SalesList
    },
    {
      path: "sales/:saleId",
      name: "Sale Detail",
      component: SalePage,
      props: true
    }
  ]
};

const terminalsMenu = {
  path: "/terminals",
  component: DashboardLayout,
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "/",
      name: "Terminals",
      component: TerminalsList
    },
    {
      path: ":terminalId",
      name: "Terminal Detail",
      component: TerminalPage,
      props: true
    }
  ]
};

const payoutsMenu = {
  path: "/payouts",
  component: DashboardLayout,
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "/",
      name: "Payouts",
      component: PayoutsList
    },
    {
      path: ":payoutId",
      name: "Payout Detail",
      component: PayoutPage,
      props: true
    }
  ]
};

const submerchantsMenu = {
  path: "/drivers",
  component: DashboardLayout,
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "/",
      name: "Submerchants",
      component: SubmerchantsList
    },
    {
      path: "performance",
      name: "Submerchants Performance",
      component: SubmerchantsPerformanceList
    },
    {
      path: ":submerchantId",
      name: "Submerchant Detail",
      component: SubmerchantPage,
      props: true
    },
    {
      path: ":submerchantId/performance",
      name: "Submerchant Performance",
      component: SubmerchantPerformancePage,
      props: true
    }
  ]
};

const developerMenu = {
  path: "/developer",
  component: DashboardLayout,
  meta: {
    authRequired: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "/",
      name: "Developer",
      component: DevelopersPage
    },
    {
      path: "endpoints/:endpointId/notifications",
      name: "Endpoint Notifications",
      component: EndpointNotifications,
      props: true
    }
  ]
};

const routes = [
  loginPage,
  registerPage,
  forgottenPasswordPage,
  resetPasswordPage,
  accountSelectPage,
  dashboardMenu,
  transactionsMenu,
  terminalsMenu,
  payoutsMenu,
  submerchantsMenu,
  developerMenu,
  userMenu,
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    path: "/status",
    beforeEnter: (to, from, next) => {
      location.href = "https://status.cabcard.services";
    }
  },
  {
    path: "/support",
    beforeEnter: (to, from, next) => {
      location.href = "https://support.cabcard.services";
    }
  },
  { path: "*", component: NotFound }
];

export default routes;
